import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";


@Component({
    selector: "wbo-color-column",
    templateUrl: "./color-column.component.html",
    styleUrls: ["./color-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => ColorColumnComponent), multi: true}
    ]
})
export class ColorColumnComponent extends AbstractColumnComponent {
    @Input() allowAlpha: boolean = true;

    constructor(injector: Injector) {
        super(injector);
    }
}
